"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _get = _interopRequireDefault(require("lodash/get"));
var _styles = require("@material-ui/core/styles");
var _withWidth = _interopRequireDefault(require("@material-ui/core/withWidth"));
var _colors = require("@material-ui/core/colors");
var _Card = _interopRequireDefault(require("@material-ui/core/Card"));
var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));
var _Switch = _interopRequireDefault(require("@material-ui/core/Switch"));
var _i18n = require("../../../../../Framework/i18n");
var _AnalyticsWrapper = _interopRequireDefault(require("../../../../Shared/Components/Analytics/AnalyticsWrapper"));
var _InformationTag = _interopRequireDefault(require("../../../../Shared/Components/InformationTag/InformationTag"));
var _customClassName = _interopRequireDefault(require("../../../../Utils/customClassName"));
var _PopupAreaProvider = require("../../Layouts/PopupAreaProvider");
var _ColorPalettes = _interopRequireDefault(require("../../Containers/ColorPalettes"));
var _Select = _interopRequireDefault(require("../Select"));
var _ObjectTools = _interopRequireDefault(require("../ObjectTools"));
var _TextFormatIcon = require("./TextFormatIcon");
var _excluded = ["children", "editorBackgroundColor"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  var _textControlboxIconsG, _WrapperAlignment, _cardContentRoot;
  return {
    card: {
      borderTop: '7px solid ' + theme.palette.primary.main,
      position: 'relative',
      overflow: 'visible'
    },
    cardUnboxed: {
      borderTop: 'none',
      boxShadow: 'none',
      borderRadius: 0
    },
    CardContentWrapper: _defineProperty({
      padding: 8
    }, theme.breakpoints.down('xs'), {
      '&:last-child': {
        paddingBottom: 8
      }
    }),
    listItemText: {
      textAlign: 'left'
    },
    fontFamilyList: _defineProperty({
      height: 40
    }, theme.breakpoints.down('xs'), {
      height: 56
    }),
    listFontItemText: {
      fontSize: '12px',
      color: theme.palette.text.secondary,
      textAlign: 'center',
      lineHeight: 2.1,
      cursor: 'default'
    },
    GridItemXS: _defineProperty({
      padding: '0 2px'
    }, theme.breakpoints.down('xs'), {
      display: 'flex'
    }),
    disabledIncrementButton: {
      opacity: 0.2
    },
    disabledDecrementButton: {
      opacity: 0.2
    },
    activeIncrementButton: {
      opacity: 1,
      cursor: 'pointer',
      color: theme.palette.text.secondary
    },
    activeDecrementButton: {
      opacity: 1,
      cursor: 'pointer',
      color: theme.palette.text.secondary
    },
    textToolButton: _defineProperty({
      width: 40,
      height: 40,
      minWidth: 30,
      minHeight: 30,
      margin: '16px 8px 0 0'
    }, theme.breakpoints.down('xs'), {
      width: 42,
      height: 42,
      marginRight: 8,
      marginTop: 8
    }),
    textToolButtonPressed: {
      background: '#ddd'
    },
    textToolButtonAlignment: _defineProperty({
      margin: '16px 8px 0 0'
    }, theme.breakpoints.down('xs'), {
      margin: 0,
      marginRight: 8
    }),
    textControlboxIconsGrid: (_textControlboxIconsG = {
      display: 'inline-flex',
      '@media only screen and (min-device-width: 568px) and (max-device-width : 725px) and  (orientation: portrait)': {
        '& div': {
          flexWrap: 'wrap'
        }
      }
    }, _defineProperty(_textControlboxIconsG, theme.breakpoints.between('xs', 'sm'), {
      '& div': {
        display: 'flex'
      }
    }), _defineProperty(_textControlboxIconsG, theme.breakpoints.down('xs'), {
      '& button:last-child': {
        marginRight: 0
      },
      justifyContent: 'space-around',
      '& .object-btn': {
        marginRight: 8,
        width: 42,
        height: 42
      }
    }), _textControlboxIconsG),
    WrapperAlignment: (_WrapperAlignment = {
      textAlign: 'end'
    }, _defineProperty(_WrapperAlignment, theme.breakpoints.between('xs', 'sm'), {
      textAlign: 'start'
    }), _defineProperty(_WrapperAlignment, theme.breakpoints.down('xs'), {
      textAlign: 'end'
    }), _WrapperAlignment),
    textToolButtonAlign: _defineProperty({
      margin: '15px 0',
      '&.Mui-disabled': {
        opacity: 0.5
      }
    }, theme.breakpoints.down('xs'), {
      marginTop: 8
    }),
    inputTextfield: {
      padding: '11.5px 14px'
    },
    colorSwitchBase: {
      color: _colors.grey[100],
      '&$colorChecked': {
        color: '#ED1C29',
        '& + $colorBar': {
          backgroundColor: '#FA9798'
        }
      }
    },
    colorBar: {},
    colorChecked: {},
    textEditor: {
      marginBottom: 16,
      '& > div': {
        height: '56px'
      }
    },
    switchRoot: {
      margin: '0 5px 0 15px'
    },
    switchLabel: {
      '& > span': {
        fontSize: 15
      }
    },
    cardContentRoot: (_cardContentRoot = {}, _defineProperty(_cardContentRoot, theme.breakpoints.down('xs'), {
      padding: 0,
      '&:last-child': {
        paddingBottom: 24
      }
    }), _defineProperty(_cardContentRoot, "padding", 8), _cardContentRoot),
    icon: {
      height: 16,
      padding: 4
    }
  };
};
var ContainerField = /*#__PURE__*/function (_React$Component) {
  _inherits(ContainerField, _React$Component);
  var _super = _createSuper(ContainerField);
  function ContainerField() {
    _classCallCheck(this, ContainerField);
    return _super.apply(this, arguments);
  }
  _createClass(ContainerField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        editorBackgroundColor = _this$props.editorBackgroundColor,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement(_TextField["default"], _extends({
        InputProps: {
          startAdornment: children,
          inputComponent: function inputComponent() {
            return null;
          },
          style: {
            background: editorBackgroundColor
          }
        }
      }, otherProps));
    }
  }]);
  return ContainerField;
}(_react["default"].Component);
var TextControlbox = /*#__PURE__*/function (_React$Component2) {
  _inherits(TextControlbox, _React$Component2);
  var _super2 = _createSuper(TextControlbox);
  function TextControlbox() {
    var _this;
    _classCallCheck(this, TextControlbox);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "onCloseColorPalettes", function () {
      _this.props.popupArea.dismiss();
    });
    return _this;
  }
  _createClass(TextControlbox, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.popupArea.dismiss();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        classes = _this$props2.classes,
        width = _this$props2.width,
        boxed = _this$props2.boxed,
        textValue = _this$props2.textValue,
        handleChangeText = _this$props2.handleChangeText,
        fontValue = _this$props2.fontValue,
        fonts = _this$props2.fonts,
        handleChangeFont = _this$props2.handleChangeFont,
        renderEditorComponent = _this$props2.renderEditorComponent,
        handleButtonMouseDown = _this$props2.handleButtonMouseDown,
        handleButtonClick = _this$props2.handleButtonClick,
        handleObjectButtonClick = _this$props2.handleObjectButtonClick,
        popupArea = _this$props2.popupArea,
        isBold = _this$props2.isBold,
        boldDisabled = _this$props2.boldDisabled,
        isItalic = _this$props2.isItalic,
        italicDisabled = _this$props2.italicDisabled,
        textAlign = _this$props2.textAlign,
        flipToFrontDisabled = _this$props2.flipToFrontDisabled,
        flipToBackDisabled = _this$props2.flipToBackDisabled,
        colorDisabled = _this$props2.colorDisabled,
        isActiveBulkName = _this$props2.isActiveBulkName,
        isBulkName = _this$props2.isBulkName,
        toggleIsBulkName = _this$props2.toggleIsBulkName,
        editorBackgroundColor = _this$props2.editorBackgroundColor,
        color = _this$props2.color,
        selectedObject = _this$props2.selectedObject,
        FontFamilySelect = _this$props2.components.FontFamilySelect,
        isPortraitMode = _this$props2.isPortraitMode;
      var textAlignFullEnabled = false;
      var renderEditor = function renderEditor() {
        return renderEditorComponent ? /*#__PURE__*/_react["default"].createElement(ContainerField, {
          className: classes.textEditor,
          label: isBulkName ? '' : (0, _i18n.t)('textControlbox.text'),
          margin: "normal",
          fullWidth: true,
          variant: "outlined",
          multiline: true,
          editorBackgroundColor: editorBackgroundColor
        }, renderEditorComponent(_this2.props)) : /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
          className: classes.textEditor,
          label: isBulkName ? '' : (0, _i18n.t)('textControlbox.text'),
          value: textValue,
          onChange: handleChangeText,
          margin: "normal",
          fullWidth: true,
          variant: "outlined",
          multiline: true,
          rowsMax: 2,
          InputLabelProps: {
            shrink: true
          }
        });
      };
      var renderBulkName = function renderBulkName() {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true,
          xs: 10
        }, /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
          className: classes.switchLabel,
          control: /*#__PURE__*/_react["default"].createElement(_Switch["default"], {
            classes: {
              root: classes.switchRoot,
              switchBase: classes.colorSwitchBase,
              checked: classes.colorChecked,
              track: classes.colorBar
            },
            onChange: toggleIsBulkName,
            onClick: toggleIsBulkName,
            checked: isBulkName
          }),
          label: (0, _i18n.t)('textControlbox.bulknames')
        })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
          item: true,
          xs: 2
        }, (0, _i18n.translationExists)('bulkNameInformation') && /*#__PURE__*/_react["default"].createElement("div", {
          className: "info-btn"
        }, /*#__PURE__*/_react["default"].createElement(_InformationTag["default"], {
          infoText: (0, _i18n.t)('bulkNameInformation')
        }))));
      };
      var renderFontFamily = function renderFontFamily() {
        return /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
          targetId: "text_font"
        }, /*#__PURE__*/_react["default"].createElement(FontFamilySelect, {
          bold: true,
          value: fontValue || '',
          autoWidth: width === 'xs',
          onChange: handleChangeFont
        }, fonts.map(function (font) {
          return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
            key: font.isCustomFont ? font.customName : font.name,
            className: classes.fontFamilyList,
            value: font,
            "aria-label": font.name
          }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
            className: classes.listItemText,
            noWrap: true,
            style: {
              fontFamily: font.value
            }
          }, font.isCustomFont ? "".concat(font.customName, " (").concat((0, _i18n.t)('textControlbox.customFont'), ")") : font.name));
        })));
      };
      var renderTextBoldItalics = function renderTextBoldItalics() {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
          targetId: "text_bold"
        }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          className: classes.textToolButton + (isBold ? ' ' + classes.textToolButtonPressed : ''),
          variant: "outlined",
          value: "bold",
          onMouseDown: handleButtonMouseDown,
          onClick: handleButtonClick,
          disabled: boldDisabled
        }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
          title: (0, _i18n.t)('textControlbox.tooltips.bold')
        }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], null, "format_bold")))), /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
          targetId: "text_italic"
        }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          className: classes.textToolButton + (isItalic ? ' ' + classes.textToolButtonPressed : ''),
          variant: "outlined",
          value: "italic",
          onMouseDown: handleButtonMouseDown,
          onClick: handleButtonClick,
          disabled: italicDisabled
        }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
          title: (0, _i18n.t)('textControlbox.tooltips.italic')
        }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], null, "format_italic")))));
      };
      var renderTextAlignments = function renderTextAlignments() {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
          targetId: "text_align_left"
        }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          className: classes.textToolButton + ' ' + classes.textToolButtonAlignment + (textAlign === 'left' || textAlign === 'start' ? ' ' + classes.textToolButtonPressed : ''),
          variant: "outlined",
          value: "justifyLeft",
          onMouseDown: handleButtonMouseDown,
          onClick: handleButtonClick
        }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
          title: (0, _i18n.t)('textControlbox.tooltips.alignLeft')
        }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], null, "format_align_left")))), /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
          targetId: "text_align_center"
        }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          className: classes.textToolButton + ' ' + classes.textToolButtonAlignment + (textAlign === 'center' ? ' ' + classes.textToolButtonPressed : ''),
          variant: "outlined",
          value: "justifyCenter",
          onMouseDown: handleButtonMouseDown,
          onClick: handleButtonClick
        }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
          title: (0, _i18n.t)('textControlbox.tooltips.alignCenter')
        }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], null, "format_align_center")))), /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
          targetId: "text_align_right"
        }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          className: classes.textToolButton + ' ' + classes.textToolButtonAlignment + (textAlign === 'right' ? ' ' + classes.textToolButtonPressed : ''),
          variant: "outlined",
          value: "justifyRight",
          onMouseDown: handleButtonMouseDown,
          onClick: handleButtonClick
        }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
          title: (0, _i18n.t)('textControlbox.tooltips.alignRight')
        }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], null, "format_align_right")))), textAlignFullEnabled && /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
          targetId: "text_align_justify"
        }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          className: classes.textToolButton + ' ' + classes.textToolButtonAlignment + (textAlign === 'full' ? ' ' + classes.textToolButtonPressed : ''),
          variant: "outlined",
          value: "justifyFull",
          onMouseDown: handleButtonMouseDown,
          onClick: handleButtonClick
        }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], null, "format_align_justify"))));
      };
      var renderTextColor = function renderTextColor() {
        return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          className: classes.textToolButtonAlign + ' ' + classes.textToolButton,
          variant: "outlined",
          value: "color",
          onClick: function onClick() {
            return popupArea.setContent( /*#__PURE__*/_react["default"].createElement(_ColorPalettes["default"], {
              isPortraitMode: isPortraitMode,
              selectedObject: selectedObject,
              closeColorPalettes: _this2.onCloseColorPalettes
            }), {
              hideChildren: !(width !== 'xs' && isPortraitMode)
            });
          },
          disabled: colorDisabled
        }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
          title: (0, _i18n.t)('textControlbox.tooltips.color')
        }, /*#__PURE__*/_react["default"].createElement(_TextFormatIcon.TextFormatIcon, {
          className: classes.icon,
          selectedColor: (0, _get["default"])(color, 'value') || _colors.grey[900]
        })));
      };
      var renderObjectTools = function renderObjectTools() {
        return /*#__PURE__*/_react["default"].createElement(_ObjectTools["default"], {
          handleObjectButtonClick: handleObjectButtonClick,
          flipToFrontDisabled: flipToFrontDisabled,
          flipToBackDisabled: flipToBackDisabled
        });
      };
      return width === 'xs' ? /*#__PURE__*/_react["default"].createElement(_Card["default"], {
        id: "containerTextControl",
        className: (0, _clsx["default"])(boxed ? classes.card : classes.cardUnboxed, (0, _customClassName["default"])('text-tools-box'))
      }, /*#__PURE__*/_react["default"].createElement(_CardContent["default"], {
        classes: {
          root: classes.cardContentRoot
        }
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        className: classes.GridItemXS
      }, renderEditor()), isActiveBulkName && renderBulkName(), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        className: classes.GridItemXS
      }, renderFontFamily()), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        justify: "flex-end",
        className: classes.GridItemXS
      }, renderTextBoldItalics(), renderTextColor()), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        alignItems: "flex-end",
        className: classes.textControlboxIconsGrid
      }, renderObjectTools(), renderTextAlignments())))) : /*#__PURE__*/_react["default"].createElement(_Card["default"], {
        id: "containerTextControl",
        className: (0, _clsx["default"])(boxed ? classes.card : classes.cardUnboxed, (0, _customClassName["default"])('text-tools-box'))
      }, /*#__PURE__*/_react["default"].createElement(_CardContent["default"], {
        className: boxed ? '' : classes.CardContentWrapper
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        md: 12,
        lg: 12,
        className: classes.GridItemXS
      }, renderEditor()), isActiveBulkName && renderBulkName(), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 12,
        md: 12,
        lg: 12,
        className: classes.GridItemXS
      }, renderFontFamily()), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        md: 12,
        lg: 12,
        className: classes.textControlboxIconsGrid
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 4,
        md: 4
      }, renderTextBoldItalics()), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        md: 6
      }, renderTextAlignments()), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 2,
        md: 2,
        className: classes.WrapperAlignment
      }, renderTextColor())), renderObjectTools())));
    }
  }]);
  return TextControlbox;
}(_react["default"].Component);
_defineProperty(TextControlbox, "defaultProps", {
  components: {
    FontFamilySelect: _Select["default"]
  }
});
var _default = exports["default"] = (0, _withWidth["default"])()((0, _styles.withStyles)(styles, {
  name: 'TextControlbox'
})((0, _PopupAreaProvider.withPopupArea)(TextControlbox)));